import React from 'react';
import { Box, Heading, Paragraph, Anchor } from 'grommet';
import styled from 'styled-components';
import clipArt from 'granite-admin/core/components/DashboardLayout/components/clipart.png';
const BigHeading = styled(Heading)`
  font-size: 8rem;
  margin-top: 2rem;
`;
const NotFoundPage = () => {
  return /*#__PURE__*/React.createElement(Box, {
    justify: "start",
    background: {
      image: `url(${clipArt})`
    },
    height: "100vh",
    width: "100%",
    pad: "large"
  }, /*#__PURE__*/React.createElement(BigHeading, {
    level: 1,
    weight: "bold"
  }, "404 !!"), /*#__PURE__*/React.createElement(Paragraph, {
    size: "xlarge"
  }, "Maybe this page moved? Got deleted?", /*#__PURE__*/React.createElement("br", null), "Is hiding out in quarantine?", /*#__PURE__*/React.createElement("br", null), "Never existed in the first place?"), /*#__PURE__*/React.createElement(Paragraph, {
    size: "xlarge"
  }, "Let's go ", /*#__PURE__*/React.createElement(Anchor, {
    label: "home",
    href: "/login"
  }), " and try from there."));
};
export default NotFoundPage;